/**
 * Represents the type of a [[Seat]].
 *
 * @remarks
 * Each seat type may be rendered differently, and have may have its own rules regarding [[Seat]] selection.
 */
export var SeatType;
(function (SeatType) {
    /**
     * A standard single seat.
     */
    SeatType["Normal"] = "Normal";
    /**
     * A space temporarily or permanently reserved for a single wheelchair (or similar special need) to occupy.
     */
    SeatType["Wheelchair"] = "Wheelchair";
    /**
     * A seat temporarily or permanently reserved for companions of customers using a [[Wheelchair]] seat.
     */
    SeatType["Companion"] = "Companion";
    /**
     * A seat belonging to a seat group, specifically the leftmost seat in a sofa.
     */
    SeatType["SofaLeft"] = "SofaLeft";
    /**
     * A seat belonging to a seat group, specifically one of the middle seats in a sofa.
     */
    SeatType["SofaMiddle"] = "SofaMiddle";
    /**
     * A seat belonging to a seat group, specifically the rightmost seat in a sofa.
     */
    SeatType["SofaRight"] = "SofaRight";
})(SeatType || (SeatType = {}));
//# sourceMappingURL=seat-type.js.map